import { useState } from "react";
import "./Orders.scss";

import { isEmpty } from "lodash";
import OrderDescriptionBox from "./OrderDescriptionBox";
import OrderStatusHoverBox from "./OrderStatusHoverBox";
import OrdersThreeDotMenu from "./OrdersThreeDotMenu";
import { useDispatch, useSelector } from "react-redux";
import {
  setOrdersSection,
  setSelectedOrderData,
  setShowMapBoxMap,
  setSingleOrderView,
  setShowGenerateScheduleConfig,
  setShowScenarioConfigDropdown,
  removeOrderImmediately,
  showErrorGenerateSchedulePopupConfig
} from "../../../../store/UnifiedControlPlaneSlice";
import { ORDER_STATUS } from "../../UnifiedControlPlane.constants";
import ScheduleView from "../Schedule/ScheduleView";

import UnifiedControlPlaneService from "../../UnifiedControlPlane.service";
import { truncateName } from "../../../../utils/commonFunctions";
import GenerateScheduleConfig from "../Schedule/GenerateScheduleConfig";
import { OrdersDropdownArrow, PlusIcon } from "../../assets/icons/Icons";



const OrdersView = ({ props, ucpViewer, mission_id, scenarioId }) => {
  const dispatch = useDispatch();

  const activeOrdersSection = useSelector(
    (state) => state.unifiedControlPlane.activeOrdersSection
  );
  const orders = useSelector((state) => state.unifiedControlPlane.orders);
  const mapLoading = useSelector(state => state.unifiedControlPlane.mapLoading);
  const showGenerateScheduleConfig = useSelector(
    (state) => state.unifiedControlPlane.showGenerateScheduleConfig
  );
  const selectedScenario = useSelector(state => state.unifiedControlPlane.selectedScenario);
  const scenarioCurrentTime = useSelector(
    (state) => state.unifiedControlPlane.scenarioCurrentTime
  );
  const [threeDotOptionsMenu, setThreeDotOptionsMenu] = useState();
  const [isThreeDotOptionsVisible, setIsThreeDotOptionsVisible] =
    useState(true);

  const [headerElement, setHeaderElement] = useState({
    status: {
      state: "",
    },
    spec: {
      name: "",
    },
    orderId: "",
  });

  const [orderDescriptionBoxVisibility, setOrderDescriptionBoxVisibility] = useState({ display: "none" });

  const createNewOrder = () => {
    props.setIsOrdersBarVisible(false);
    props.setIsOrderCreationModal(true);
    dispatch(setShowMapBoxMap(true));
  };

  const openGenerateScehduleConfig = () => {
    if (!selectedScenario || isEmpty(selectedScenario)) {
      dispatch(showErrorGenerateSchedulePopupConfig("Please connect a scenario to generate schedule"));
      return;
    }
    dispatch(setShowGenerateScheduleConfig(true));
    dispatch(setShowScenarioConfigDropdown(false))
  };

  const showSingleOrderBar = (item) => {
    dispatch(
      UnifiedControlPlaneService.getOrderAssignmentsForSingleOrder(
        mission_id,
        item.orderId
      )
    );
    dispatch(setSelectedOrderData(item));
    dispatch(setSingleOrderView(true));
    threeDotMenuClose();
  };

  const showOrderDescriptionBoxOnHover = (e, item, type) => {
    setHeaderElement(item);
    setOrderDescriptionBoxVisibility({ display: "block" });
  };

  const showOrderDescriptionBoxOffHover = (e, item, type) => {
    setOrderDescriptionBoxVisibility({ display: "none" });
  };

  const [hoverBoxNotificationVisibility, setHoverBoxNotificationVisibility] =
    useState({ display: "none" });
  const [hoverBoxElement, setHoverBoxElement] = useState({
    isType: "",
    name: "",
    orderId: "",
  });

  const showHoverBoxNotificationOnHover = (e, item, type) => {
    if (item && Object.keys(item).length > 0) {
      setHeaderElement(item);
      setHoverBoxElement({
        isType: type,
        name: item.spec.name,
        orderId: item?.orderId,
      });
    } else {
      setHoverBoxElement({ isType: type });
    }
    setHoverBoxNotificationVisibility({ display: "block" });
  };

  const showHoverBoxNotificationOffHover = (e, item) => {
    setHoverBoxNotificationVisibility({ display: "none" });
  };

  const threeDotMenuClick = (event, item, type) => {
    event.stopPropagation();
    if (type) {
      setThreeDotOptionsMenu(type);
    } else {
      setThreeDotOptionsMenu(item?.orderId);
    }
    setIsThreeDotOptionsVisible(true);
  };

  const threeDotMenuClose = () => {
    setThreeDotOptionsMenu("");
    setIsThreeDotOptionsVisible(false);
  };

  const handleOptimisticDelete = (orderId) => {
    dispatch(removeOrderImmediately(orderId));
  };

  const RenderOrder = (item, i) => (
    <div
      className={`orderTypeItem mouse-cursor-pointer activeHeaderBar`}
      key={`${item?.status?.state}-${i}`}
      onClick={(e) => {
        showSingleOrderBar(item);
        threeDotMenuClose();
      }}
      onMouseEnter={(e) => showOrderDescriptionBoxOnHover(e, item)}
      onMouseLeave={(e) => showOrderDescriptionBoxOffHover(e, item)}
      style={
        orderDescriptionBoxVisibility.display === "block" &&
          headerElement?.orderId === item.orderId
          ? { background: "rgba(204, 245, 78, 0.10)" }
          : {}
      }
    >
      <div className="orderTitleDiv">
        <div className="orderTitlePriorityIcon">
          {item?.spec.attributes.priorityLane === "Normal" && (
            <img
              src={require("../../assets/raw/Normal.svg").default}
              alt=""
            />
          )}
          {item?.spec.attributes.priorityLane === "High" && (
            <img
              src={require("../../assets/raw/High.svg").default}
              alt=""
            />
          )}
          {item?.spec.attributes.priorityLane === "ASAP" && (
            <img
              src={require("../../assets/raw/Asap.svg").default}
              alt=""
            />
          )}
        </div>
        <div className="orderTitleName" title={item?.spec?.name}>
          {truncateName(item?.spec?.name)}
        </div>
      </div>

      <div className="orderProgressDiv">
        {item.spec.attributes.recurring && (
          <div
            className="orderProgressBtn"
            onMouseEnter={(e) => showHoverBoxNotificationOnHover(e, item, "Recurring")}
            onMouseLeave={(e) => showHoverBoxNotificationOffHover(e, item)}
          >
            <img
              src={require("../../assets/raw/RecurringIcon.svg").default}
              alt=""
            />
          </div>
        )}
        {item.status.state === "Executed" && (
          <div className="orderProgressBtn"
            onMouseEnter={(e) => showHoverBoxNotificationOnHover(e, item, item.status.state)}
            onMouseLeave={(e) => showHoverBoxNotificationOffHover(e, item)}
          >
            <img
              src={require("../../assets/raw/GreenTickSmallIcon.svg").default}
              alt=""
            />
          </div>
        )}
        {/* {item.status.state === "Current" && (
        <div className="orderProgressDiv mouse-cursor-pointer">
          <div onMouseEnter={(e) => showHoverBoxNotificationOnHover(e, item, item.status.state)} onMouseLeave={(e) => showHoverBoxNotificationOffHover(e, item)}>
            <CircularProgressBarComponent item={item} />
          </div>
        </div>
        )} */}
        {item.status.state === "Pending" && (
          <div
            className="orderProgressBtn"
          // onMouseEnter={(e) => showHoverBoxNotificationOnHover(e, item, item.status.state)}
          // onMouseLeave={(e) => showHoverBoxNotificationOffHover(e, item)}
          >
            <img
              src={require("../../assets/raw/OrderPendingIcon.svg").default}
              alt=""
            />
          </div>
        )}
        <div
          className="orderProgressThreeDotBtn mouse-cursor-pointer "
          onClick={(e) => {
            e.stopPropagation();
            threeDotMenuClick(e, item);
          }}
        >
          <img src={require("../../assets/raw/ThreeDotIcon.svg").default} alt="" />
          {threeDotOptionsMenu === item?.orderId && isThreeDotOptionsVisible && (
            <OrdersThreeDotMenu item={item} onMenuClose={threeDotMenuClose} onDelete={handleOptimisticDelete} />
          )}
        </div>
        <div className="hoverBoxParentContainer">
          {hoverBoxElement?.orderId === item.orderId && (
            <OrderStatusHoverBox
              headerElement={headerElement}
              hoverBoxNotificationVisibility={hoverBoxNotificationVisibility}
              type={hoverBoxElement.isType}
            />
          )}
        </div>
      </div>
    </div>
  );

  const isGenerateDisabled =
    selectedScenario?.status === "SimulationRunning" ? isEmpty(scenarioCurrentTime) : false;


  return (
    <>
      {props.isOrdersBarVisible && headerElement.status.state !== "" && (
        <OrderDescriptionBox
          headerElement={headerElement}
          orderDescriptionBoxVisibility={orderDescriptionBoxVisibility}
          ucpViewer={ucpViewer}
        />
      )}
      {<ScheduleView mission_id={mission_id} scenarioId={scenarioId} />}
      {/* {<ViewerSettings viewer={ucpViewer} viewerId={scenarioId ?? "default-ucp"} viewType={VIEW_TYPES.UCP} />} */}
      {props.isOrdersBarVisible && (
        <div className="ordersBar">

          <div className="ordersGreenHeaderBar ordersHeadingSection">
            <div className="orders d-flex">
              <button className="ordersGreenHeader mouse-cursor-normal">
                Orders
              </button>
              <div
                onClick={() => createNewOrder()}
                className="addNewOrderBtn"
              >
                <PlusIcon />
              </div>
            </div>
          </div>

          <div className="ordersBarBody">
            <div className="orders-section">
              <div
                className={`ordersTypeHeaderBar mouse-cursor-pointer ${activeOrdersSection === ORDER_STATUS.EXECUTED ? "activeOrdersTypeHeaderBar" : ""}`}
                onClick={() => {
                  activeOrdersSection !== ORDER_STATUS.EXECUTED
                    ? dispatch(setOrdersSection(ORDER_STATUS.EXECUTED))
                    : dispatch(setOrdersSection(""));
                }}
              >
                <div
                  className="ordersDropdownArrow"
                >
                  <OrdersDropdownArrow isActive={activeOrdersSection === ORDER_STATUS.EXECUTED} />
                </div>
                <div
                  className={`ordersTypeHeader ${activeOrdersSection === ORDER_STATUS.EXECUTED
                    ? "activeHeader"
                    : ""
                    }`}
                >
                  Executed Orders
                  <span>({orders.executed.length})</span>
                </div>
              </div>
              {activeOrdersSection === ORDER_STATUS.EXECUTED && (
                <div className="orders-list">
                  {orders.executed.length > 0 && orders.executed.map(RenderOrder)}
                </div>
              )}
            </div>

            <div className="orders-section">
              <div
                className={`ordersTypeHeaderBar mouse-cursor-pointer ${activeOrdersSection === ORDER_STATUS.CURRENT ? "activeOrdersTypeHeaderBar" : ""}`}
                onClick={() => {
                  activeOrdersSection !== ORDER_STATUS.CURRENT
                    ? dispatch(setOrdersSection(ORDER_STATUS.CURRENT))
                    : dispatch(setOrdersSection(""));
                }}
              >
                <div
                  className="ordersDropdownArrow"
                >
                  <OrdersDropdownArrow isActive={activeOrdersSection === ORDER_STATUS.CURRENT} />
                </div>
                <div
                  className={`ordersTypeHeader ${activeOrdersSection === ORDER_STATUS.CURRENT
                    ? "activeHeader"
                    : ""
                    }`}
                >
                  Current Orders
                  <span>({orders.current.length})</span>
                </div>
              </div>
              {activeOrdersSection === ORDER_STATUS.CURRENT && (
                <div className="orders-list">
                  {orders.current.length > 0 && orders.current.map(RenderOrder)}
                </div>
              )}
            </div>
            <div className="orders-section">
              <div
                className={`ordersTypeHeaderBar mouse-cursor-pointer ${activeOrdersSection === ORDER_STATUS.PENDING ? "activeOrdersTypeHeaderBar" : ""}`}
                onClick={() => {
                  activeOrdersSection !== ORDER_STATUS.PENDING
                    ? dispatch(setOrdersSection(ORDER_STATUS.PENDING))
                    : dispatch(setOrdersSection(""));
                }}
              >
                <div
                  className="ordersDropdownArrow"
                >
                  <OrdersDropdownArrow isActive={activeOrdersSection === ORDER_STATUS.PENDING} />
                </div>
                <div
                  className={`ordersTypeHeader ${activeOrdersSection === ORDER_STATUS.PENDING
                    ? "activeHeader"
                    : ""
                    }`}
                >
                  Pending Orders
                  <span >({orders.pending.length})</span>
                </div>
              </div>
              {activeOrdersSection === ORDER_STATUS.PENDING && (
                <div className="orders-list">
                  {orders.pending.length > 0 && orders.pending.map(RenderOrder)}
                </div>
              )}
            </div>
          </div>
          <div className="ordersBarFooter">
            <button
              className="generateScheduleBtn"
              onClick={openGenerateScehduleConfig}
              disabled={isGenerateDisabled}
              style={{ opacity: isGenerateDisabled ? 0.7 : 1 }}
            >
              <span className="btn-text">Generate Schedule</span>
            </button>
            {showGenerateScheduleConfig && (
              <GenerateScheduleConfig mission_id={mission_id} scenarioId={scenarioId} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OrdersView;
